var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1650_14103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 10.0003C1.66797 6.07195 1.66797 4.10777 2.88836 2.88738C4.10875 1.66699 6.07293 1.66699 10.0013 1.66699C13.9297 1.66699 15.8939 1.66699 17.1142 2.88738C18.3346 4.10777 18.3346 6.07195 18.3346 10.0003C18.3346 13.9287 18.3346 15.8929 17.1142 17.1133C15.8939 18.3337 13.9297 18.3337 10.0013 18.3337C6.07293 18.3337 4.10875 18.3337 2.88836 17.1133C1.66797 15.8929 1.66797 13.9287 1.66797 10.0003Z",
    stroke: "#858585",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5 13.167L5.95238 14.167L8.33333 11.667",
    stroke: "#858585",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5 7.33301L5.95238 8.33301L8.33333 5.83301",
    stroke: "#858585",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.832 7.5L14.9987 7.5",
    stroke: "#858585",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.832 13.333L14.9987 13.333",
    stroke: "#858585",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1650_14103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/SettingsIcon.a3b8c23911d0f0badbe67979725ddf2a.svg";
export { ForwardRef as ReactComponent };